var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _g, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNewspaper(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 306,
    height: 300,
    viewBox: "0 0 306 300",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M198.16 27.75H231.06C234.849 27.75 237.92 30.8213 237.92 34.61V239.38C237.92 255.722 249.686 269.691 265.79 272.47C266.35 272.57 266.92 272.65 267.5 272.72C268.3 272.82 269.12 272.88 269.97 272.91C270.25 272.91 270.53 272.91 270.82 272.91C271.61 272.91 272.4 272.91 273.18 272.91H274.05H274.35H33.14C15.2992 272.861 0.837818 258.431 0.75 240.59V33.89C0.75 30.499 3.49897 27.75 6.89 27.75H184.06",
    fill: "#E0E0E0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M198.16 27.75H231.06C234.849 27.75 237.92 30.8213 237.92 34.61V239.38C237.92 255.722 249.686 269.691 265.79 272.47C266.35 272.57 266.92 272.65 267.5 272.72C268.3 272.82 269.12 272.88 269.97 272.91C270.25 272.91 270.53 272.91 270.82 272.91C271.61 272.91 272.4 272.91 273.18 272.91H274.05H274.35H33.14C15.2992 272.861 0.837818 258.431 0.75 240.59V33.89C0.75 30.499 3.49897 27.75 6.89 27.75H184.06",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5 259.65C21.7858 258.289 15.7226 252.289 14.28 244.59",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.28 49.54V40.29C14.3074 37.9126 16.2425 35.9998 18.62 36H28.15",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M89.4099 108.42H208.58",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1499 108.42H79.8499",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M194.13 135.22H209.02",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M129.51 135.22H184.06",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M163.93 163.43H209.02",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M129.51 163.43H153.35",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M194.13 191.64H208.58",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M129.51 191.64H184.06",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M97.97 219.15H208.58",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1499 219.15H89.4099",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M284.07 74.25V236C284.128 242.884 278.809 248.619 271.94 249.08C268.46 249.247 265.064 247.981 262.542 245.578C260.02 243.175 258.592 239.844 258.59 236.36V71.19H281C281.813 71.1873 282.594 71.5085 283.17 72.0827C283.746 72.6568 284.07 73.4367 284.07 74.25Z",
    fill: "#828282",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M271.45 200.24L271.49 233.81",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M271.33 83.7799L271.45 194.04",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M302 88.81C303.718 88.81 305.11 90.2024 305.11 91.92V238.72C305.11 256.72 291.06 271.89 273.4 272.89C272.56 272.94 271.72 272.96 270.87 272.94C270.58 272.94 270.3 272.94 270.02 272.94C269.18 272.94 268.35 272.85 267.55 272.75C266.97 272.68 266.4 272.6 265.84 272.5C249.736 269.721 237.97 255.752 237.97 239.41V54H256.97C257.412 54 257.836 54.1763 258.147 54.4897C258.459 54.8032 258.633 55.228 258.63 55.67V236.35C258.631 239.834 260.059 243.165 262.582 245.568C265.104 247.971 268.5 249.237 271.98 249.07C278.829 248.59 284.124 242.866 284.07 236V88.81H302Z",
    fill: "#BDBDBD",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M289.2 254.44C293.039 250.116 295.157 244.533 295.15 238.75V88.8101",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M247.83 99.27V238.75C247.83 251.817 258.423 262.41 271.49 262.41V262.41C275.941 262.415 280.303 261.16 284.07 258.79",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M247.83 57.86V89.51",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M119 132V141L96.3599 167.32L82.5199 156.32L56.3399 187L47.0999 179.4L29.6699 197C28.6441 196.897 27.8647 196.031 27.8699 195V132C27.8699 130.895 28.7653 130 29.8699 130H117C118.104 130 119 130.895 119 132Z",
    fill: "#F2F2F2",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M119 132V141L96.3599 167.32L82.5199 156.32L56.3399 187L47.0999 179.4L29.6699 197C28.6441 196.897 27.8647 196.031 27.8699 195V132C27.8699 130.895 28.7653 130 29.8699 130H117C118.104 130 119 130.895 119 132Z",
    fill: "white",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M119 140.93V195C119 196.105 118.104 197 117 197H29.6699L47.0999 179.4L56.3399 187L82.5199 156.3L96.3599 167.3L119 140.93Z",
    fill: "#828282",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2798 142.12H63.7098",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2798 152.63H57.0798",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M62.8099 72.94V86.52H51.4199V55.86H64.1199L71.5699 69.44V55.86H82.9999V86.52H70.2499L62.8099 72.94Z",
    fill: "white",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M99.6 77.76H112.74V86.52H88.21V55.86H111.86V64.62H99.6V66.81H111V75.57H99.6V77.76Z",
    fill: "white",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M145.37 72.72L147.78 55.86H159.6L153 86.52H140.3L137.05 71L133.76 86.55H121.06L114.49 55.89H126.32L128.72 72.75L132 55.86H142.07L145.37 72.72Z",
    fill: "white",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M172.08 77.58C172.546 77.6055 173.005 77.4675 173.38 77.19C173.653 76.9898 173.822 76.6779 173.84 76.34C173.84 75.98 173.54 75.67 172.96 75.41C172.38 75.15 171.64 74.86 170.77 74.54C169.9 74.22 168.94 73.84 167.92 73.4C166.897 72.9548 165.941 72.3692 165.08 71.66C164.185 70.9226 163.442 70.0194 162.89 69C162.269 67.8142 161.966 66.4878 162.01 65.15C162.013 63.9385 162.316 62.7466 162.89 61.68C163.5 60.5159 164.348 59.4937 165.38 58.68C166.554 57.7588 167.881 57.0513 169.3 56.59C170.974 56.0407 172.728 55.7737 174.49 55.8C176.244 55.7625 177.991 56.0194 179.66 56.56C180.937 56.9912 182.169 57.5437 183.34 58.21C184.439 58.8771 185.448 59.6838 186.34 60.61L182.18 67.05C181.635 66.6507 181.056 66.2994 180.45 66C179.871 65.675 179.261 65.4071 178.63 65.2C177.932 64.9617 177.198 64.8434 176.46 64.85C175.998 64.8268 175.542 64.9646 175.17 65.24C174.895 65.4382 174.725 65.7512 174.71 66.09C174.71 66.45 175 66.76 175.59 67.02C176.18 67.28 176.9 67.58 177.78 67.89C178.66 68.2 179.6 68.6 180.62 69.05C181.643 69.5043 182.602 70.0928 183.47 70.8C184.367 71.5224 185.112 72.4165 185.66 73.43C186.277 74.6173 186.58 75.9426 186.54 77.28C186.532 78.4908 186.23 79.6816 185.66 80.75C185.047 81.9144 184.195 82.9366 183.16 83.75C181.986 84.6728 180.659 85.3835 179.24 85.85C177.564 86.3924 175.811 86.6559 174.05 86.63C171.958 86.6744 169.871 86.4013 167.86 85.82C166.384 85.3832 164.965 84.7758 163.63 84.01C162.433 83.3262 161.366 82.4358 160.48 81.38L164.64 75.08C165.274 75.5922 165.965 76.0285 166.7 76.38C167.463 76.7327 168.252 77.0269 169.06 77.26C170.047 77.5065 171.063 77.6142 172.08 77.58V77.58Z",
    fill: "white",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M179.71 249.61L185.4 259.83",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M183.96 242.9L193.61 260.26",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M193.3 245.35L196.48 251.07",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewspaper);
export default __webpack_public_path__ + "static/media/newspaper.d53ead19a5684d9995fb7f13e0e0441c.svg";
export { ForwardRef as ReactComponent };